import axios from "@/plugins/axios";

let url = "/api/v1/me/employment/contract";

export const contract = {
    get() {
        return axios.get(url).then((result) => result.data);
    },
    put(data) {
        return axios.put(url, data).then((result) => result.data);
    },
};

export default contract;
